import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'QuitLevelPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'c79b4f84-b7b7-47f5-8a0f-015ebbdd3ad9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_background',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: '5147b987-0d82-4361-818f-9854f170e748',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'ef4e3b84-f860-4fd8-a26f-cc1c93776607',
      type: 'Text',
      name: 'header_txt',
      nameSpace: '',
      className: '',
      x: 0,
      y: -300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'AreYouSure',
      localize: true,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: '67eb6e41-c730-4cdc-932b-04ab23a48d93',
      type: 'Sprite',
      name: 'plinkoSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: -64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'plinko_quit_level',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: '6f21aeed-5128-4692-a23d-21c11b2df703',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 345,
      y: -265,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'c7080225-17a7-4e5e-a97e-c6840f24abed',
      type: 'Text',
      name: 'plinkoText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 139,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlinkoQuitLevel',
      localize: true,
      maxWidth: 718,
      maxHeight: 138,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8a352a',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'b781974a-2385-4a26-84d2-cbc2a1a141c7',
      type: 'Sprite',
      name: 'underlay',
      nameSpace: '',
      className: '',
      x: 0,
      y: 42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'level_complete_underlay',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'b34e5083-7e49-4d40-8a6e-dcebc1f757da',
      type: 'Text',
      name: 'levelText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -39,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level',
      localize: true,
      maxWidth: 718,
      maxHeight: 138,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#9c4236',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'cda9fc62-f61f-4862-af96-d4b73ce92850',
      type: 'Text',
      name: 'quitText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'QuitLevel?',
      localize: true,
      maxWidth: 718,
      maxHeight: 138,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#872b2c',
        stroke: '#8a352a',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'df76af3f-a8b7-4a69-8f3f-eb8ffad20be4',
      type: 'Sprite',
      name: 'keepPlayingButton',
      nameSpace: '',
      className: '',
      x: 190,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: 'd92bcbe1-0b25-4b08-8f6f-b66bf28da63d',
      type: 'Sprite',
      name: 'quitLevelButton',
      nameSpace: '',
      className: '',
      x: -190,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_red',
      parent: '3cf309a5-1c12-4425-baf4-4ee62814435a',
      data: ''
    },
    {
      id: '1e4d944d-a77b-4e80-879e-b43d2ec4434b',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'KeepPlaying',
      localize: true,
      maxWidth: 213,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'df76af3f-a8b7-4a69-8f3f-eb8ffad20be4',
      data: ''
    },
    {
      id: '11ac0131-6fca-4e3d-8ffb-69da105ec086',
      type: 'Text',
      name: 'quitButtonText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'QuitLevel',
      localize: true,
      maxWidth: 175,
      maxHeight: 73,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#81242c',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 140,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd92bcbe1-0b25-4b08-8f6f-b66bf28da63d',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class QuitLevelPopupLayout {
  static raw = raw;
  root: PIXI.Container
  header_txt: PIXI.Text
  plinkoSprite: PIXI.Sprite
  closeButton: PIXI.Sprite
  plinkoText: PIXI.Text
  underlay: PIXI.Sprite
  levelText: PIXI.Text
  quitText: PIXI.Text
  keepPlayingButton: PIXI.Sprite
  quitLevelButton: PIXI.Sprite
  quitButtonText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
